import React, {Component} from 'react';
import {toast} from 'react-toastify';
import {withTranslation} from 'react-i18next';
import {APIClient} from "../../../utils/APIClient";
import {URLQueryStringParser} from "../../../utils/URLQueryStringParser";
import {API_URL} from '../../../settings/local_settings';
import {Loading} from "../../Loading";


import {withRouterParams} from "../../../utils/withRouterParams";

let oauthExchangeInFlight = false;

class ConnectGSCAccount extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        let code = new URLQueryStringParser().getUrlParams('code');
        if (!code) {
            this.props.history.push('/agency/conections');
            return;
        }
        try {
            const url = new URL(window.location.href);
            ['code', 'scope', 'authuser', 'prompt', 'state', 'hd'].forEach((p) => url.searchParams.delete(p));
            window.history.replaceState({}, '', url.pathname + (url.search || ''));
        } catch (e) { /* noop */ }
        if (oauthExchangeInFlight) {
            this.props.history.push('/agency/conections');
            return;
        }
        const guardKey = 'connecting_gsc_oauth_code';
        if (sessionStorage.getItem(guardKey) === code) {
            this.props.history.push('/agency/conections');
            return;
        }
        oauthExchangeInFlight = true;
        sessionStorage.setItem(guardKey, code);
        let credential_label = localStorage.getItem('pending_credential_label');
        localStorage.removeItem('pending_credential_label');
        const failed = () => {
            oauthExchangeInFlight = false;
            sessionStorage.removeItem(guardKey);
            // Texto propio, nunca el del backend: llega en inglés o en voseo (card 5qObKTLi).
            toast.error(this.props.t('connections.oauth.error_generic'));
            this.props.history.push('/agency/conections');
        };
        new APIClient(API_URL + 'get_access_tokens/gsc/').call('POST', {'code': code, 'credential_label': credential_label}).then((data) => {
            if (data && data.status === 'OK') {
                this.props.history.push('/agency/conections');
                toast.success(this.props.t('connections.gsc.connected_ok'));
                return;
            }
            failed();
        }).catch(failed)
    }

    render() {
        return <Loading message={this.props.t('connections.oauth.connecting')}/>
    }
}

export default withTranslation()(withRouterParams(ConnectGSCAccount));
